import React, { useState, useEffect } from 'react';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import Header from './Header';
import Sidebar from './SideBar';
import BranchModal from './BranchModal';

const Branch = () => {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');

    // State Variables
    const [branches, setBranches] = useState([
        { location: 'Branch 1', contact: '123-456-7890', email: 'branch1@example.com', serviceFee: 1000, registrationFee: 200, active: true },
        { location: 'Branch 2', contact: '987-654-3210', email: 'branch2@example.com', serviceFee: 1200, registrationFee: 250, active: false },
        { location: 'Branch 3', contact: '555-555-5555', email: 'branch3@example.com', serviceFee: 1500, registrationFee: 300, active: true },
    ]);

    // Pagination State
    const [filteredPlans, setFilteredPlans] = useState(branches);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const totalPages = Math.ceil(filteredPlans.length / itemsPerPage);

    useEffect(() => {
        const filtered = branches.filter((branch) =>
            Object.values(branch).some((value) =>
                String(value).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
        setFilteredPlans(filtered);
        setCurrentPage(1); // Reset to first page on new search
    }, [searchQuery, branches]);

    // Toggle Active Status
    const toggleActive = (index) => {
        const updatedBranches = [...branches];
        updatedBranches[index].active = !updatedBranches[index].active;
        setBranches(updatedBranches);
    };

    const handleSearch = (e) => setSearchQuery(e.target.value);
    // Delete an Update
    const handleDelete = (index) => {
        const currentData = branches.filter((_, i) => i !== index);
        setBranches(currentData);
    };

    // Pagination Handler
    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    // Get Current Updates
    const startIndex = (currentPage - 1) * itemsPerPage;
    const currentUpdates = filteredPlans.slice(startIndex, startIndex + itemsPerPage);

    return (
        <>
            <div className="oms-header">
                <h1 className="dashboard-title">Branch</h1>

                {/* Add Fees Button */}
                <button className="oms-add-btn" onClick={() => setIsModalOpen(true)}>
                    Add Branch
                </button>
            </div>

            {/* Search Filter */}
            <div className="filter-search">
                <div className="filter-search-input">
                    <input
                        type="search"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearch}
                    />
                    <i className="fa fa-search"></i> {/* Font Awesome Search Icon */}
                </div>
            </div>

            {/* Branch Table */}
            <div className="customer-table">
                <table>
                    <thead>
                        <tr>
                            <th>Location/Branch</th>
                            <th>Contact</th>
                            <th>Email</th>
                            <th>Service/Subscription Fee</th>
                            <th>Registration Fee (One Time)</th>
                            <th>Status</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentUpdates.length > 0 ? (
                            currentUpdates.map((branch, index) => (
                                <tr key={index}>
                                    <td>{branch.location}</td>
                                    <td>{branch.contact}</td>
                                    <td>{branch.email}</td>
                                    <td>{branch.serviceFee}</td>
                                    <td>{branch.registrationFee}</td>
                                    <td>
                                        <button onClick={() => toggleActive(index)} className="toggle-btn">
                                            <i className={`fa ${branch.active ? 'fa-toggle-on' : 'fa-toggle-off'}`}></i>
                                        </button>
                                    </td>
                                    <td>
                                        <button onClick={() => setIsModalOpen(true)}>
                                            <i className="fa-solid fa-pencil edit-oms"></i>
                                        </button>
                                        <button onClick={() => handleDelete(index)}>
                                            <i className="fa-solid fa-trash delete-oms"></i>
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="7" style={{ textAlign: 'center' }}>
                                    No branches found.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            {/* Pagination */}
            <div className="pagination">
                <button
                    onClick={() => paginate(currentPage - 1)}
                    disabled={currentPage === 1}
                >
                    Previous
                </button>
                {Array.from({ length: totalPages }, (_, index) => (
                    <button
                        key={index}
                        onClick={() => paginate(index + 1)}
                        className={currentPage === index + 1 ? 'active' : ''}
                    >
                        {index + 1}
                    </button>
                ))}
                <button
                    onClick={() => paginate(currentPage + 1)}
                    disabled={currentPage === totalPages}
                >
                    Next
                </button>
            </div>
            <BranchModal isOpen={isModalOpen} setIsOpen={setIsModalOpen} />
        </>
    );
};

export default Branch;
